import * as React from 'react';
import { MouseEvent } from 'react';
import Input from './Input';
import CompanySelection from './CompanySelection';
import { API_URL } from '../constants/constants';

interface LoginFormProps {
  login: (email: string, password: string) => void;
  selectCompany: (company: string) => void;
  selectedCompany: string;
}

interface LoginState {
  email: string;
  password: string;
}

class LoginForm extends React.Component<LoginFormProps, LoginState> {
  constructor(props: LoginFormProps) {
    super(props);
    this.state = { email: '', password: '' };
  }

  login(e: MouseEvent<HTMLInputElement>) {
    e.preventDefault();
    this.props.login(this.state.email, this.state.password);
  }

  render() {
    return (
      <div className="login">
        <div className="login__header"><h2>Kirjaudu sisään</h2></div>
        <div className="login__content">
          <form className="login-form" onSubmit={event => event.preventDefault()}>
            <div className="input-wrapper">
              <label htmlFor="login-name">Sähköposti</label>
              <Input
                id={'login-name'}
                type={'email'}
                placeholder={'Sähköposti'}
                required={true}
                onChange={value => this.setState({ email: value })}
                value={this.state.email}
                name={'username'}
                hideErrorMessages={true}
              />
            </div>
            <div className="input-wrapper">
              <label htmlFor="login-pass">Salasana</label>
              <Input
                id={'login-pass'}
                type={'password'}
                placeholder={'Salasana'}
                required={true}
                onChange={value => this.setState({ password: value })}
                value={this.state.password}
                name={'password'}
                hideErrorMessages={true}
              />
            </div>
            <CompanySelection
              selectCompany={company => this.props.selectCompany(company)}
              selectedCompany={this.props.selectedCompany}
            />
            <input type="submit" value="Kirjaudu sisään" onClick={(e) => this.login(e)}/>
          </form>
        </div>
        <div className="login-help">
          <a href={`${API_URL}/user/logout`}>Ongelmia kirjautumisessa</a>
          <a href={`${API_URL}/user/password`}>Palauta salasana</a>
        </div>
      </div>
    );
  }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/LoginForm.tsx